import React from 'react'
import Plotly from 'plotly.js-basic-dist-min'
import createPlotlyComponent from 'react-plotly.js/factory'
import { Container } from '@material-ui/core'

const Plot = createPlotlyComponent(Plotly)

const GraphDisplay = ({
  dataX,
  dataY,
  dataX2,
  dataY2,
  title
}) => {
  return (
    <Container className="chart-area">
      <Plot
        data={[
          {
            x: dataX,
            y: dataY,
            type:'scatter',
            marker: { color: 'blue' },
            name: 'Indoor',
            hoverinfo: 'x+y'
          },
          {
            x: dataX2,
            y: dataY2,
            type: 'bar',
            marker: { color: 'red' },
            name: 'Outdoor',
            hoverinfo: 'x+y'
          }
        ]}
        layout={{ width: 1000, height: 500, title: title, plot_bgcolor:'rgb(7, 7, 7, .4)', paper_bgcolor:'rgb(7, 7, 7, .4)', font: {
          size: 12,
          color: 'white'
        }, xaxis:{
          tickangle:'45', gridwidth:'', tick0:'x',
        } }}
        config={{
          responsive:true,
        }}
      />
    </Container>
  )
}

export default GraphDisplay